export const MISSION_LABEL_KEYS = {
  DAILY_LOGIN: "setting_account.mission_daily_login",
  DAILY_CAMPAIGN: "setting_account.mission_send_campaign",
  DAILY_SCAN_CUSTOMER: "setting_account.mission_scan_customer",
  WEEKLY_GEN_AI: "setting_account.mission_genai",
};

export const MISSION_FREQ_KEYS = {
  daily: "setting_account.mission_freq_daily",
  weekly: "setting_account.mission_freq_weekly",
  unlimited: "setting_account.mission_freq_unlimited",
};

export function getMappedMissions(missions) {
  return (Array.isArray(missions) ? missions : []).filter(
    (item) => item && MISSION_LABEL_KEYS[item.id]
  );
}
